/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon} from "react-share";
import { InputRow } from "aws-amplify-react";
import { useSelector } from "react-redux";
import { inviteStudent } from "../../analytics";

const ShareAppLink = ({ showModal, onClose, onSubmit }) => {
    const [, setVisibility] = useState(false)
    const { teacher_details } = useSelector(({ dashboard }) => dashboard);
    const [sharelink, setSharelink] = useState("")

    useEffect(() => {
        setVisibility(showModal)
    }, [showModal])

    useEffect(() => {
        const { schoolId } = teacher_details || {}
        if (schoolId) {
            setSharelink(getShareLink(schoolId))
        }
    }, [teacher_details])
    const onOk = () => {
        setVisibility(false)
        if (onSubmit) onSubmit()
    }
    const onCancel = () => {
        setVisibility(false)
        if (onClose) onClose()
    }
    const shareIconSize = 32
    const getShareLink = (school_id) => {
        const referrer = encodeURIComponent(`utm_source=classroom&utm_medium=teachershare&utm_term=invitestudent&schoolid=${school_id}`)
        const link = `https://play.google.com/store/apps/details?id=com.vidyanext.quiznext&referrer=${referrer}`
        return link
    }
    return (
        <Modal
            title="Share this link with your students."
            centered
            visible={showModal}
            onOk={() => onOk()}
            onCancel={() => onCancel()}
            okButtonProps={{ visible: false }}
            cancelButtonProps={{ visible: false }}
            footer={false}
            maskClosable = {false}
        >
            <InputRow disabled value={sharelink} />
            <FacebookShareButton url={sharelink} style={{ padding: 5 }}  onShareWindowClose={()=>{
                inviteStudent(sharelink,"facebook")
            }}>
                <FacebookIcon size={shareIconSize} round />
            </FacebookShareButton>
            <WhatsappShareButton url={sharelink} style={{ padding: 5 }} onShareWindowClose={()=>{
                inviteStudent(sharelink,"whatsapp")
            }}>
                <WhatsappIcon size={shareIconSize} round />
            </WhatsappShareButton>
            <TwitterShareButton url={sharelink} style={{ padding: 5 }} onShareWindowClose={()=>{
                inviteStudent(sharelink,"twiiter")
            }}>
                <TwitterIcon size={shareIconSize} round />
            </TwitterShareButton>
            <EmailShareButton url={sharelink} style={{ padding: 5 }} onShareWindowClose={()=>{
                inviteStudent(sharelink,"email")
            }}>
                <EmailIcon size={shareIconSize} round />
            </EmailShareButton>
            
        </Modal>
    )
}

export default ShareAppLink;